export const findMatchingRowIndicator = (indicators, data, checkFilter) => {
    const indicatorList = Array.isArray(indicators)
        ? indicators
        : (indicators ? [indicators] : [])

    return indicatorList.find(indicator => {
        if (typeof indicator?.when === 'function') {
            return Boolean(indicator.when(data))
        }
        return Boolean(indicator?.filter && checkFilter(indicator.filter, data))
    }) || null
}
